<template>
    <div>
        <div class="text-center">
            <h2>Θεοδώρα Ντάναση</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo-Theodora_Ntanasi.jpg')" />
                <p class="cv-text">
                    Η Θεοδώρα Ντάναση είναι υποψήφια Διδάκτωρ στο Εργαστήριο Κηπευτικών Καλλιεργειών, του Τμήματος Επιστήμης Φυτικής Παραγωγής του Γεωπονικού Πανεπιστημίου Αθηνών, με επιβλέπουσα την Επίκουρη Καθηγήτρια Δρ. Γεωργία Ντάτση. Η μελέτη της διδακτορικής της διατριβής περιλαμβάνει την αξιολόγηση τοπικών ποικιλιών σολανωδών κηπευτικών από την περιοχή της Μεσογείου, ως προς την παραγωγή, την ποιότητα, θρεπτική κατάσταση και φυσιολογία, καλλιεργούμενων υδροπονικά υπό αλατούχο καταπόνηση. Έχει λάβει πτυχίο γεωπόνου στην ειδικότητα των Κηπευτικών Καλλιεργειών από το Γεωπονικό Πανεπιστήμιο Αθηνών το 2019. Από το 2020 έχει συμμετάσχει στην ερευνητική ομάδα δύο ευρωπαϊκών ερευνητικών προγραμμάτων VEG-ADAPT και RADIANT, πέντε εθνικών ερευνητικών προγραμμάτων (NUTRISENSE, VF2FARM, OPTIMUS, ΒΙΟΠΡΟΣΑΡΜΟΓΗ, DSS-ΚΗΠΕΥΤΙΚΩΝ) και σε ένα ιδιωτικό πρόγραμμα (Yara International).Τα κύρια ερευνητικά της ενδιαφέροντα περιλαμβάνουν  την θρέψη, την ποιότητα, την αξιολόγηση τοπικών ποικιλιών και την φυσιολογία καταπόνησης των κηπευτικών καλλιεργειών. Το συγγραφικό της έργο περιλαμβάνει 9 εργασίες δημοσιευμένες σε έγκριτα διεθνή επιστημονικά περιοδικά με κριτές που διαθέτουν Impact Factor στο Journal Citation Reports και 6 επιστημονικές εργασίες σε πλήρη πρακτικά διεθνών συνεδρίων.
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
